<mat-nav-list class="sd_bar">
  <button class="closeSidebar" (click)="toggleSidenav()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="logo-brand">
    <figure class="logo" routerLink="/dashboard">
      <img [src]="assetsConst.logo" alt="logo" />
    </figure>
    <figure class="logo1">
      <img [src]="assetsConst.logoMin" alt="logo" />
    </figure>
  </div>
  @for (item of sideBar; track $index) {
    <div>
      @if (!item.isSubMenu) {
        <mat-list-item
          class="mat-list-item"
          [routerLink]="item.path"
          [ngClass]="{ active: isActive(item.label) }"
          [matTooltip]="item.label"
          matTooltip="Tooltip!"
          matTooltipPosition="right"
          (click)="toggleSidenav()">
          <figure class="sd_cn">
            <img [src]="item.img" alt="" />
          </figure>
          <div class="sidenav-item">
            <h5 class="lead">{{ item.label | translate }}
              @if (item?.hasPointer) {
                <span class="count">{{ (item?.pointerCount ?? 0) > 0 ? item?.pointerCount : '' }}</span>
              }
            </h5>
          </div>
        </mat-list-item>
      }
      @if (item.isSubMenu) {
        <mat-accordion>
          <mat-expansion-panel [expanded]="isActive(item.label)">
            <mat-expansion-panel-header
              class="drop_lst_nv"
              [ngClass]="{ active: isActive(item.label) }">
              <mat-panel-title>
                <mat-list-item
                  [matTooltip]="item.label"
                  matTooltip="Tooltip!"
                  matTooltipPosition="right"
                  class="drop_lst_sbmn_hd"
                  (click)="toggleSidenav()"
                  [ngClass]="{ active: isActive(item.label) }">
                  <figure class="sd_cn" mat-raised-button>
                    <img [src]="item.img" alt="" />
                  </figure>
                  <div class="sidenav-item">
                    <h5 class="lead">{{ item.label | translate }}
                      @if (item?.hasPointer) {
                        <span class="count">{{ (item?.pointerCount ?? 0) > 0 ? item?.pointerCount : '' }}</span>
                      }
                    </h5>
                  </div>
                </mat-list-item>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @for (sub of item.subMenuItems; track $index) {
              <mat-list-item
                [routerLink]="sub.path"
                [ngClass]="{ active: isSubMenuActive(sub.path) }"
                matTooltip="{{ item.label }}"
                matTooltip="Tooltip!"
                matTooltipPosition="right"
                class="sub-menu-item"
                (click)="toggleSidenav()">
                <div
                  class="right-arrow"
                  *ngIf="isSubMenuActive(sub.path)"></div>
                <figure class="sd_cn h_w_30">
                  <img [src]="sub.img" alt="images" />
                </figure>
                <div class="sidenav-item">
                  <h5 class="lead">{{ sub.label | translate }}
                      @if (sub?.hasPointer) {
                        <span class="count">{{ (sub?.pointerCount ?? 0) > 0 ? sub?.pointerCount : '' }}</span>
                      }
                  </h5>
                </div>
              </mat-list-item>
            }
          </mat-expansion-panel>
        </mat-accordion>
      }
    </div>
  }

  <div class="contact">
    @for (item of lowerSideBar; track $index) {
      @if (item.isSubMenu) {
        <mat-accordion>
          <mat-expansion-panel [expanded]="isActive(item.label)">
            <mat-expansion-panel-header
              class="drop_lst_nv"
              [ngClass]="{ active: isActive(item.label) }">
              <mat-panel-title>
                <mat-list-item
                  [matTooltip]="item.label"
                  matTooltip="Tooltip!"
                  matTooltipPosition="right"
                  class="drop_lst_sbmn_hd"
                  (click)="toggleSidenav()"
                  [ngClass]="{ active: isActive(item.label) }">
                  <figure class="sd_cn" mat-raised-button>
                    <img [src]="item.img" alt="" />
                  </figure>
                  <div class="sidenav-item">
                    <h5 class="lead">{{ item.label | translate }}</h5>
                  </div>
                </mat-list-item>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @for (sub of item.subMenuItems; track $index) {
              <mat-list-item
                [routerLink]="sub.path"
                [ngClass]="{ active: isSubMenuActive(sub.path) }"
                matTooltip="{{ item.label }}"
                matTooltipPosition="right"
                class="sub-menu-item"
                (click)="toggleSidenav()">
                <div
                  class="right-arrow"
                  *ngIf="isSubMenuActive(sub.path)"></div>
                <figure class="sd_cn h_w_30">
                  <img [src]="sub.img" alt="images" />
                </figure>
                <div class="sidenav-item">
                  <h5 class="lead">{{ sub.label | translate }}</h5>
                </div>
              </mat-list-item>
            }
          </mat-expansion-panel>
        </mat-accordion>
      } @else {
        <mat-list-item
          [routerLink]="item.path"
          [ngClass]="{ active: isActive(item.label) }"
          [matTooltip]="item.label"
          matTooltip="Tooltip!"
          matTooltipPosition="right"
          (click)="toggleSidenav()">
          <figure class="sd_cn">
            <img [src]="item.img" alt="" />
          </figure>
          <div class="sidenav-item">
            <h5 class="lead">{{ item.label | translate }}</h5>
          </div>
        </mat-list-item>
      }
    }
  </div>
</mat-nav-list>
